import { Injectable } from '@angular/core';
import { IupicsProcess } from '@iupics-manager/models/iupics-data';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class CompiereProcessService {
  private url: string;
  private executionUrl: string;

  constructor(private http: ApiService) {}

  getProcess(processId: any): Observable<IupicsProcess> {
    if (this.url === undefined) {
      this.url = environment.config.backend.ws.url + environment.config.backend.ws.paths['processUI'];
    }
    return this.http.get<IupicsProcess>(`${this.url}/${processId}`);
  }

  executeProcess(params: any): Observable<any> {
    if (this.executionUrl === undefined) {
      this.executionUrl = environment.config.backend.ws.url + environment.config.backend.ws.paths['printReport'];
    }
    return this.http.post<any>(`${this.executionUrl}`, params);
  }
}
